import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';

export default class TKStatusConsole extends TKCustomElementFactory {
    viewportElement?: HTMLElement;

    constructor() {
        super();

        this.viewportElement = this.closest('[data-tk-viewport]') || undefined;
    }

    connectedCallback(): void {
        if (!this.viewportElement) throw new Error('Status Console: Missing Viewport Element!');
        this.resize();
        this.registerViewportListener();
    }

    registerViewportListener() {
        const onResize = this.resize.bind(this);
        this.pushListener({
            event: 'tk-viewport-resize',
            element: this.viewportElement!,
            action: onResize,
        });
    }

    resize() {
        document.documentElement.style.setProperty('--offset-top', `${this.clientHeight}px`);
    }
}
